/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PalAuthSubmission } from './PalAuthSubmission';
import {
    PalAuthSubmissionFromJSON,
    PalAuthSubmissionFromJSONTyped,
    PalAuthSubmissionToJSON,
} from './PalAuthSubmission';

/**
 * 
 * @export
 * @interface ReviewPalAuthSubmission200Response
 */
export interface ReviewPalAuthSubmission200Response {
    /**
     * 
     * @type {PalAuthSubmission}
     * @memberof ReviewPalAuthSubmission200Response
     */
    data?: PalAuthSubmission;
}

/**
 * Check if a given object implements the ReviewPalAuthSubmission200Response interface.
 */
export function instanceOfReviewPalAuthSubmission200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ReviewPalAuthSubmission200ResponseFromJSON(json: any): ReviewPalAuthSubmission200Response {
    return ReviewPalAuthSubmission200ResponseFromJSONTyped(json, false);
}

export function ReviewPalAuthSubmission200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReviewPalAuthSubmission200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : PalAuthSubmissionFromJSON(json['data']),
    };
}

export function ReviewPalAuthSubmission200ResponseToJSON(value?: ReviewPalAuthSubmission200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': PalAuthSubmissionToJSON(value.data),
    };
}

